export default "__VITE_ASSET__DlMKFY_0__"